import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import ar from './locales/ar.json'

export const RTL_LANGUAGES = new Set(['ar'])

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, ar: { translation: ar } },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: { caches: ['localStorage'] },
  })

function applyDirection(lng: string) {
  const dir = RTL_LANGUAGES.has(lng) ? 'rtl' : 'ltr'
  document.documentElement.dir = dir
  document.documentElement.lang = lng
}

applyDirection(i18next.resolvedLanguage ?? 'en')
i18next.on('languageChanged', applyDirection)

export default i18next
